import { gql, useQuery } from "@apollo/client";

import {
  FieldFilterDefinition,
  GraphicsQuery,
} from "../../generated/gql/graphql";

const GET_GRAPHICS = gql`
  query Graphics($query: GraphicQuery) {
    graphics(query: $query) {
      id
      name
      asset {
        thumbnailUrl
        url
        width
        height
      }
    }
  }
`;

type Props = {
  searchQuery: string;
  filters: FieldFilterDefinition[];
};

export type UseGraphicsResult = {
  loading: boolean;
  error: string | undefined;
  data: GraphicsQuery | undefined;
  refetch: () => void;
};

export default function useGraphics(props: Props): UseGraphicsResult {
  const { searchQuery, filters } = props;

  const { loading, error, data, refetch } = useQuery(GET_GRAPHICS, {
    fetchPolicy: "no-cache",
    variables: {
      query: {
        filter: {
          name: {
            contains: searchQuery,
          },
          fields: filters.map((filter) => ({
            fieldName: filter.fieldName,
            anyOf: filter.options.map((option) => option.value),
          })),
        },
      },
    },
  });

  async function handleRefetch(): Promise<void> {
    await refetch({
      query: {
        filter: {
          name: {
            contains: searchQuery,
          },
          fields: filters.map((filter) => ({
            fieldName: filter.fieldName,
            anyOf: filter.options.map((option) => option.value),
          })),
        },
      },
    });
  }

  return {
    loading,
    error: error?.message,
    data,
    refetch: handleRefetch,
  };
}
